import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PartFilter from './partmasters-filter';
import PartTable from './partmasters-table';
import PartTile from './partmasters-tile';
import PartSearch from './partmasters-search';
import { selectPartFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const PartContent = props => {
  const isFilterVisible = useSelector(selectPartFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <PartSearch />
        </div>
        {/* {isFilterVisible && <PartFilter />} */}

        {!showTileView ? <PartTable /> : <PartTile />}
      </div>
    </div>
  );
};

export default PartContent;
